import { AppState } from 'reducers';

export const getAudioSync = (state: AppState) => state.audioSync;
